export const DOMAIN = process.env.REACT_APP_DOMAIN;
export const GOOGLE_MAPS_API_KEY = process.env.REACT_APP_GOOGLE_MAPS_API_KEY;
export const ENV_PRODUCTION = process.env.REACT_APP_ENV_PRODUCTION;
export const FB_PIXEL_ID = process.env.REACT_APP_FB_PIXEL_ID;
export const SEGMENT_WRITE_KEY = process.env.REACT_APP_SEGMENT_WRITE_KEY;
export const NODE_ENV = process.env.REACT_APP_NODE_ENV;
export const TOUR_BE_API = process.env.REACT_APP_TOUR_BE_API;
export const WIDGET_API = process.env.REACT_APP_WIDGET_API;
export const USER_TOKEN = 'OT3OTRBN9Z36EKQD';
export const MAGICAL_KEY = 'hub@clik.vnn';
export const DEFAULT_AREA_COLOR = 'rgb(73, 168, 219)';
export const SINGLE_CLICK_DURATION_MILLISECOND = 100;
export const AUTO_FOCUS_ANIMATION_DURATION = 800;
export const IMAGE_MAP_AREA_LINE_WIDTH = 10;
export const IMAGE_MAP_AREA_STROKE_COLOR = '#ffffff'; // do not change
export const IMAGE_MAP_AREA_FILL_OPACITY = 0.72;
export const REGEX_LINK_MARKDOWN = /\[(.*?)\]\((.*?)\)/gim;
export const REGEX_IMAGE_MARKDOWN = /!\[(.*?)\]\((.*?)\)/gim;
export const DEFAULT_BACKGROUND_COLOR_AMENITY = 'rgba(0, 0, 0, 0.72)';
export const DEFAULT_ACTIVE_BACKGROUND_COLOR_AMENITY = '#fff';
export const DEFAULT_ACTIVE_TEXT_COLOR_AMENITY = '#000';
export const DEFAULT_FORMAT_DATE = 'DD/MM/YYYY';
export const DEFAULT_SIZE_NEWS = 6;
export const NEWS_GAP_PORTRAIT = 24;
export const NEWS_GAP_LANDSCAPE = 32;
export const DEFAULT_HEIGHT_IMAGE_NEWS = 345;
export const DEFAULT_COLUMN_NEWS = 2;
export const DEFAULT_SIMILAR_PROJECT_CHILD_ITEM = 10;
export const REGEX_PHONE = '^(84|84\\+|0)+([0-9]{9})$';
export const AUTO_PLAY_SPEED = 10000;
export const REGEX_EMAIL = '^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\\.[a-zA-Z]{2,4}$';
export const DEFAULT_INACTIVE_POINT_COLOR = 'rgba(0, 0, 0, 0.48)';
export const DEFAULT_CONTENT_PANEL_DISPLAY_ITEM = 3;
export const TIME_DELAY_ACTIVE_SCROLL = 300;
export const GAP_DEFAULT = 16;
export const ANIMATION_DELAY = 300;
export const TRANSITION_STYLE = 'all 300ms ease-in-out';
export const IMAGE_MAP_DELAY = 200;
export const THEME_COOKIES_KEY = 'THEME_COOKIES_KEY';
export const HOME_PROFILE_COOKIES_KEY = 'HOME_PROFILE_COOKIES_KEY';
export const DEFAULT_VALUE_SCROLL_HOOK = 0;
export const DEFAULT_WIDTH_CARD_LIST = 360;
export const FAST_SWIPE_TIME = 300; // ms
// 1090 is the best width can show 2 column (home profile container)
export const HOME_PROFILE_MAX_WIDTH_2_COLUMNS = 1090;
export const ANALYZER_TIME_DELAY = 1; // ms
export const LOGO_CLIK = `${process.env.PUBLIC_URL}/new-logo.svg`;
export const MIN_SNAP = 80;
export const SCROLL_DELAY = 300; // ms
export const CHAT_ELEMENT_ID = 'smarthubChat';
export const CHAT_PLATFORM = `${process.env.REACT_APP_CHAT_PLATFORM}`;
export const CHAT_BUNDLE_URL = `${process.env.REACT_APP_CHAT_BUNDLE_URL}`;
export const DEFAULT_API_LANGUAGE = 'vi';
export const CHAT_SCRIPT_ELEMENT_ID = 'smarthubChatScript';
export const VIRTUAL_TOUR_URL = `${process.env.REACT_APP_VIRTUAL_TOUR_URL}`;

export const LIST_SKELETON_SHORT = [1, 2, 3];
export const LIST_SKELETON_MEDIUM = [1, 2, 3, 4, 5];
export const LIST_SKELETON_LONG = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10];
